(ns manage.resource.content-function
  (:require [clojure.set :refer [rename-keys]]
            [common.url :as url]
            [common.url-template :as url-tpl]
            [manage.resource.content-function-version :as content-function-version]
            [re-frame.core :as rf]))

(rf/reg-event-fx :resource.content-function/evaluate-context
  [(rf/inject-cofx :sub :config)
   (rf/inject-cofx :sub :context)]
  (fn [{:keys [db config] :as cofx}
       [_ {:keys [context
                  content-function
                  add-request-context
                  width
                  height]
           :or {add-request-context false}}
        preview-token]]
    (when-let [token (or preview-token (get-in cofx [:context :preview-token]))]
      (let [context* (merge context {:creative {:width width :height height}})]
        {:db (assoc-in db
                       [:resource.content-function/evaluate-context context*]
                       {:state :pending})
         :http
         {:method :post
          :uri (url/parts->str [(:apiUrl config) "api"
                                "v0/content-functions"
                                token])
          :params {:addRequestContext add-request-context
                   :contentFunction content-function
                   :context context*}
          :on-success [:resource.content-function/evaluate-context-success context*]
          :on-failure [:resource.content-function/evaluate-context-failure context*]}}))))

(rf/reg-event-db :resource.content-function/evaluate-context-success
  [(rf/path :resource.content-function/evaluated-context)]
  (fn [m [_ context content]]
    (assoc-in m [context] {:state :success :value content})))

(rf/reg-event-db :resource.content-function/evaluate-context-failure
  [(rf/path :resource.content-function/evaluated-context)]
  (fn [m [_ context]]
    (assoc-in m [context] {:state :failure})))

(rf/reg-event-fx :resource.content-function/evaluate-for-studio
  [(rf/inject-cofx :sub :url-context)]
  (fn [{:keys [db url-context]} [_ payload]]
    {:db (assoc-in db [:resource.content-function/evaluate] {:state :pending :value nil})
     :http
     {:method :post
      :params payload
      :uri (url-tpl/render (:api/content-function-evaluate url-tpl/templates) (rename-keys url-context {:preview-adset-id :adset-id}) {})
      :headers {"Authorization" (str "lemonpi " (:token url-context))}
      :on-success [:resource.content-function/evaluate-success]
      :on-failure [:resource.content-function/evaluate-failure]}}))

(rf/reg-event-fx :resource.content-function/evaluate
  [(rf/inject-cofx :sub :url-context)
   (rf/inject-cofx :sub :resource.user/token)]
  (fn [{:keys [db url-context] :as cofx} [_ payload]]
    {:db (assoc-in db [:resource.content-function/evaluate] {:state :pending :value nil})
     :http
     {:method :post
      :params payload
      :uri (url-tpl/render (:api/content-function-evaluate url-tpl/templates) url-context {})
      :headers {"Authorization" (:resource.user/token cofx)}
      :on-success [:resource.content-function/evaluate-success (:context payload)]
      :on-failure [:resource.content-function/evaluate-failure]}}))

(rf/reg-event-db :resource.content-function/evaluate-success
  (fn [db [_ content-function]]
    (assoc-in db [:resource.content-function/evaluate] {:state :success :value content-function})))

(rf/reg-event-db :resource.content-function/evaluate-failure
  (fn [db _]
    (assoc-in db [:resource.content-function/evaluate] {:state :failure})))

(rf/reg-event-fx :resource.content-function/get-one
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :config)
   (rf/inject-cofx :sub :context)]
  (fn [{:keys [db config context] :resource.user/keys [token]}
       [_ {:keys [adset-id params]}]]
    (let [adset-id (or adset-id (:adset-id context))]
      {:db (assoc db :resource.content-function/one {:state :pending :value nil})
       :http {:method :get
              :uri (url/parts->str [(:apiUrl config) "api"
                                    "v0/adsets-2/"
                                    adset-id
                                    "/content-function"])
              :params params
              :headers {"Authorization" token}
              :on-success [:resource.content-function/get-one-success adset-id]
              :on-failure [:resource.content-function/get-one-failure]}})))

(rf/reg-event-fx :resource.content-function/get-one-with-stage
  [(rf/inject-cofx :sub :url-context)]
  (fn [{:keys [db url-context]} _]
    {:db (assoc db :resource.content-function/one {:state :pending :value nil})
     :http {:method :get
            :uri (url-tpl/render (:api/content-function-with-stage url-tpl/templates) url-context {})
            :headers {"Authorization" (str "lemonpi " (:token url-context))}
            :on-success [:resource.content-function/get-one-success nil]
            :on-failure [:resource.content-function/get-one-failure]}}))

(rf/reg-event-db :resource.content-function/get-one-success
  (fn [db [_ adset-id content-function]]
    (assoc db :resource.content-function/one {:state :success :adset-id adset-id :value content-function})))

(rf/reg-event-db :resource.content-function/get-one-failure
  [(rf/path :resource.content-function/one)]
  (fn [_ _]
    {:state :failure}))

(rf/reg-event-fx :resource.content-function/put-one
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :config)
   (rf/inject-cofx :sub :context)]
  (fn [{:keys [config context]
        :resource.user/keys [token]}
       [_ payload {:keys [adset-id stage on-success on-failure]
                   :or {on-success [:resource.content-function/put-one-success {:stage stage :adset-id adset-id}]
                        on-failure [:resource.content-function/put-one-failure {:stage stage}]}}]]
    {:http {:method :put
            :format :form-data
            :uri (cond-> (url/parts->str [(:apiUrl config) "api"
                                          "v0/adsets-2/"
                                          (or adset-id (:adset-id context))
                                          "/content-function"])
                   (seq stage) (str "?stage=" stage))
            :params payload
            :headers {"Authorization" token}
            :on-success on-success
            :on-failure on-failure}}))

(rf/reg-event-fx :resource.content-function/put-one-success
  (fn [_ [_ {:keys [adset-id]}]]
    {:fx [[:invalidate-queries {:queryKey ["adset" adset-id]}]]}))

(rf/reg-event-db :resource.content-function/put-one-failure
  (fn [db _]
    db))

(rf/reg-sub :resource.content-function/one
  (fn [db _]
    (:resource.content-function/one db)))

(rf/reg-event-fx :resource.content-function/create-stage
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :config)
   (rf/inject-cofx :sub :context)]
  (fn [{:keys [db config context] :as cofx} [_ stage payload]]
    {:db (assoc db :resource.content-function/create-stage {:state :pending})
     :http {:method :put
            :format :form-data
            :uri (cond-> (url/parts->str [(:apiUrl config) "api"
                                          "v0/adsets-2/"
                                          (:adset-id context)
                                          "/content-function"])
                   (seq stage) (str "?stage=" stage))
            :params payload
            :headers {"Authorization" (:resource.user/token cofx)}
            :on-success [:resource.content-function/create-stage-success]
            :on-failure [:resource.content-function/create-stage-failure]}}))

(rf/reg-event-fx :resource.content-function/create-stage-success
  (fn [{:keys [db]} _]
    {:db (assoc-in db [:resource.content-function/create-stage :state] :success)
     :dispatch [:resource.content-function/get-content-function-overview]
     :dispatch-later [{:ms 2000
                       :dispatch [:resource.content-function/reset-state :resource.content-function/create-stage]}]}))

(rf/reg-event-fx :resource.content-function/create-stage-failure
  (fn [{:keys [db]} [_ response]]
    (let [error (get-in response [:value :error])]
      {:db (assoc db :resource.content-function/create-stage {:state :failure :value error})
       :dispatch-later [{:ms 2000
                         :dispatch [:resource.content-function/reset-state :resource.content-function/create-stage]}]})))

;; Delete staged content-function
(rf/reg-event-fx :resource.content-function/delete-stage
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :config)
   (rf/inject-cofx :sub :context)]
  (fn [{:keys [db config context] :as cofx} [_ stage]]
    {:pre [(seq stage)]}
    {:db (assoc db :resource.content-function/delete-stage {:state :pending})
     :http {:method :delete
            :uri (str (url/parts->str [(:apiUrl config) "api"
                                       "v0/adsets-2/"
                                       (:adset-id context)
                                       "/content-function"])
                      "?stage="
                      stage)
            :headers {"Authorization" (:resource.user/token cofx)}
            :on-success [:resource.content-function/delete-stage-success stage]
            :on-failure [:resource.content-function/delete-stage-failure stage]}}))

(rf/reg-event-fx :resource.content-function/delete-stage-success
  [(rf/inject-cofx :sub :resource.content-function-version/version-names)]
  (fn [{:keys [db]
        :resource.content-function-version/keys [version-names]} [_ stage]]
    {:db (assoc-in db [:resource.content-function/delete-stage :state] :success)
     :dispatch-n [[:resource.content-function-version/remove-version stage]
                  [:resource.content-function/get-content-function-overview]
                  [:resource.content-function-version/activate-version
                   (->> (disj version-names stage)
                        (filter #(or (= % "published") first))
                        first)]]
     :dispatch-later [{:ms 2000
                       :dispatch [:resource.content-function/reset-state :resource.content-function/delete-stage]}]}))

(rf/reg-event-fx :resource.content-function/delete-stage-failure
  (fn [{:keys [db]} [_ response]]
    (let [error (get-in response [:value :error])]
      {:db (assoc db :resource.content-function/delete-stage {:state :failure :value error})
       :dispatch-later [{:ms 2000
                         :dispatch [:resource.content-function/reset-state :resource.content-function/delete-stage]}]})))

;; Publish a staged content-function
(rf/reg-event-fx :resource.content-function/publish-stage
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :config)
   (rf/inject-cofx :sub :context)]
  (fn [{:keys [db config context] :as cofx} [_ stage]]
    {:db (assoc db :resource.content-function/publish-stage {:state :pending})
     :http
     {:method :post
      :uri (url/parts->str [(:apiUrl config) "api"
                            "v0/adsets-2"
                            (:adset-id context)
                            (str "content-function/publish?stage=" stage "&force-delete-staged=true")])
      :headers {"Authorization" (:resource.user/token cofx)}
      :on-success [:resource.content-function/publish-stage-success]
      :on-failure [:resource.content-function/publish-stage-failure]}}))

(rf/reg-event-fx :resource.content-function/publish-stage-success
  (fn [{:keys [db]} [_ response]]
    {:db (assoc db :resource.content-function/publish-stage
                {:state :success :value response})
     ;; Not used in content-variant page
     ;; TODO: Figure out how this works and if we can get rid of the dispatch-later here
     :fx [[:dispatch-later [{:ms 2000 :dispatch [:resource.content-function/reset-state :resource.content-function/publish-stage]}]]]}))

(rf/reg-event-fx :resource.content-function/publish-stage-failure
  (fn [{:keys [db]} [_ response]]
    (let [error (get-in response [:value :error])]
      {:db (assoc db :resource.content-function/publish-stage
                  {:state :failure :value error})
       ;; Not used in content-variant page
       ;; TODO: Figure out how this works and if we can get rid of the dispatch-later here
       :fx [[:dispatch-later [{:ms 2000 :dispatch [:resource.content-function/reset-state :resource.content-function/publish-stage]}]]]})))

(rf/reg-event-db :resource.content-function/reset-state
  (fn [db [_ path]]
    (assoc-in db [path :state] nil)))

;; Get content functions overview
(rf/reg-event-fx :resource.content-function/get-content-function-overview
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [db url-context] :as cofx} _]
    {:db (assoc-in db [:resource.content-function/content-function-overview :state] :pending)
     :http
     {:method :get
      :uri (url-tpl/render :api/adset-content-function-overview url-context)
      :headers {"Authorization" (:resource.user/token cofx)}
      :on-success [:resource.content-function/get-content-function-overview-success]
      :on-failure [:resource.content-function/get-content-function-overview-failure]}}))

(rf/reg-event-fx :resource.content-function/get-content-function-overview-success
  [content-function-version/overview-success-response->versions
   (rf/inject-cofx :sub :router/path-params)]
  (fn [{:keys [db] :router/keys [path-params]} [_ versions]]
    (let [active-version-name (:resource.content-function-version/active-version-name db)
          url-version (:content-function-version path-params)
          version-ordering (cond->> ["draft" "published"]
                             ;; version is not set, and there is a version in url-context
                             (and (nil? active-version-name) url-version) (cons url-version))
          version (content-function-version/versions->available-version versions version-ordering)]
      {:db (assoc db :resource.content-function/content-function-overview
                  {:state :success :value versions})
       :fx [[:dispatch [:resource.content-function-version/set-versions versions]]
            [:dispatch [:resource.content-function-version/activate-version version]]]})))

(rf/reg-event-fx :resource.content-function/get-content-function-overview-failure
  (fn [{:keys [db]} [_ response]]
    (let [error (get-in response [:value :error])]
      {:db (assoc db :resource.content-function/content-function-overview
                  {:state :failure :value error})
       :dispatch [:resource.content-function-version/set-versions nil]})))

(rf/reg-sub
  ;; get pending state of current resource keyword
  :resource.content-function/pending?
  (fn [db [_ k]]
    (let [{:keys [state]} (get db (keyword :resource.content-function (name k)))]
      (= :pending state))))

;; Make a more dynamic subscription to avoid duplication
(doseq [k [:resource.content-function/delete-stage
           :resource.content-function/create-stage
           :resource.content-function/publish-stage]]
  (rf/reg-sub
    k
    (fn [db [_ path]]
      (get-in db (concat [k] path)))))

(rf/reg-sub :resource.content-function/state
  :<- [:resource.content-function/one]
  (fn [cfn _]
    (:state cfn)))

(rf/reg-sub :resource.content-function/value
  :<- [:resource.content-function/one]
  (fn [cfn _]
    (:value cfn)))

(rf/reg-sub :resource.content-function/meta
  :<- [:resource.content-function/value]
  (fn [cfn _]
    (:meta cfn)))
